<script setup>
defineProps({
  width: {
    type: Number,
    default: 16,
  },
  height: {
    type: Number,
    default: 16,
  },
});
</script>

<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.67883 21.623C8.2587 22.4982 10.0733 23 12.0054 23C18.0791 23 23.0001 18.0684 23.0001 11.9946C23.0001 5.92088 18.0791 1 12.0054 1C5.93161 1 1 5.92088 1 11.9946C1 13.9481 1.51241 15.7627 2.39835 17.3533L1 23L6.67883 21.623ZM7.28729 7.13777C7.54343 6.89224 7.9171 6.79618 8.2587 6.87094L8.61088 6.94566C8.96317 7.02032 9.25139 7.25521 9.39017 7.57541L10.084 9.11256C10.2548 9.48613 10.1908 9.93447 9.91318 10.244L9.48618 10.7457C9.34745 10.9058 9.31545 11.1513 9.42216 11.3435C10.6817 13.6065 12.3363 14.343 13.0728 14.5671C13.2863 14.6419 13.5319 14.5458 13.6493 14.3536L13.9588 13.8733C14.2577 13.4144 14.8448 13.2542 15.4959 13.5744L16.7769 14.2149C17.2679 14.4497 17.492 15.0261 17.3106 15.5385C16.6595 17.4279 14.9942 17.1931 14.9942 17.1931C11.3009 17.097 8.40807 13.6918 7.1592 11.9413C6.58277 11.1193 6.23052 10.1266 6.33723 9.11255C6.44403 8.10912 6.91372 7.47936 7.28729 7.13777Z"
      fill="#8C8C8C"
    />
  </svg>
</template>
